import { BaseFactory } from '../base.factory';
import { Station } from '../../model/station';
import merge from 'lodash/merge';

export class StationFactory extends BaseFactory {

    constructor() {
        super(false);
        this.requestConfig.baseURL = `${process.env.VUE_APP_GUICHE_URL}`;
        this.requestConfig.headers = merge({'X-Device': 'MARKETPLACE'}, this.requestConfig.headers);
    }

    public getStations = async () => {
        try {
            const path = `/bus/stations`;
            const result = await this.get(path) as Array<Station>;
            return result.sort((s1, s2) => { return s1.label.localeCompare(s2.label); });
        }
        catch (error) {
            throw error;
        }
    }
}
